export class CircularList<T> {
    private items: T[];
    private currentIndex: number;
    private length: number;

    constructor(items: T[], index = 0) {
        this.items = items;
        this.length = items.length;
        this.currentIndex = this.length > 0 ? this.clampIndex(index) : 0;
    }

    private clampIndex(index: number): number {
        return ((index % this.length) + this.length) % this.length;
    }

    get current(): T | null {
        return this.length > 0 ? this.items[this.currentIndex] : null;
    }

    next(): CircularList<T> {
        if (this.length === 0) {
            return this;
        }
        const nextIndex = this.clampIndex(this.currentIndex + 1);
        return new CircularList(this.items, nextIndex);
    }

    previous(): CircularList<T> {
        if (this.length === 0) {
            return this;
        }
        const prevIndex = this.clampIndex(this.currentIndex - 1);
        return new CircularList(this.items, prevIndex);
    }
}
